/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "077fcd61c74d814f71b6de6a5a023212eaed7859";
